import { motion } from 'framer-motion';
import { useMemo } from 'react';

export default function DustMotes() {
    const moteCount = 30;

    const motes = useMemo(() => [...Array(moteCount)].map((_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: Math.random() * 3 + 1,
        duration: Math.random() * 10 + 20,
        delay: Math.random() * 5,
    })), []);

    return (
        <div className="absolute inset-0 overflow-hidden pointer-events-none z-1">
            {motes.map((mote) => (
                <motion.div
                    key={mote.id}
                    className="absolute rounded-full bg-white opacity-20"
                    style={{
                        left: `${mote.x}%`,
                        top: `${mote.y}%`,
                        width: mote.size,
                        height: mote.size,
                    }}
                    animate={{
                        y: [0, -100, 0],
                        x: [0, Math.random() * 50 - 25, 0],
                        opacity: [0, 0.4, 0],
                    }}
                    transition={{
                        duration: mote.duration,
                        repeat: Infinity,
                        ease: "easeInOut",
                        delay: mote.delay,
                    }}
                />
            ))}
        </div>
    );
}
